const calCriticalLoad = (invVolt, invCurr) => {
  return Math.abs((invVolt * (invCurr / 5)) / 1000).toFixed(3);
};

const calAirconLoad = (airConObj) => {
  const { batCurrent, batVolt, recCur, recVolt } = airConObj;
  let grid = checkGrid(airConObj);
  let load;
  // grid off
  if (grid == true) {
    load = ((batVolt / 128) * (batCurrent / 1024)) / 1000;
  }
  // grid on
  else {
    load =
      ((recCur / 1024) * (recVolt / 128) -
        (batVolt / 128) * (batCurrent / 1024)) /
      1000;
  }
  // this.setGraph(load);
  return Math.abs(load).toFixed(3);
};

export const checkGrid = (airConObj) => {
  const { recVoltA, recVoltB, recVoltC } = airConObj;

  return recVoltA < 33000 && recVoltB < 33000 && recVoltC < 33000;
};

export const aircon_EMS = [
  "S1",
  "S3",
  "S5",
  "S7",
  "S9",
  "S11",
  "S13",
  "S15",
  "S17",
  "S19",
];

export const criticalEmsList = [
  "T5",
  "S4",
  "S6",
  "S8",
  "S10",
  "S2",
  "S14",
  "S16",
  "S18",
];
export const airConLoad = (emsData) => {
  if (emsData != {} && emsData["PacketType"] == 1) {
    let airConObj = {
      batCurrent: emsData["BatteryCurrent"],
      batVolt: emsData["Voltage"][2],
      recCur: emsData["Rec"]["Current"]["O"],
      recVolt: emsData["Rec"]["Volt"]["O"],
      recVoltA: emsData["Rec"]["Volt"]["A"],
      recVoltB: emsData["Rec"]["Volt"]["B"],
      recVoltC: emsData["Rec"]["Volt"]["C"],
    };
    return calAirconLoad(airConObj);
  } else {
    return null;
  }
};

export const airConLoadGraph = (emsData) => {
  let airConObj = {
    batCurrent: emsData["battery"][0],
    batVolt: emsData["volt"][0],
    recCur: emsData["rec"][0],
    recVolt: emsData["rec"][2],
    recVoltA: emsData["rec"][3],
    recVoltB: emsData["rec"][4],
    recVoltC: emsData["rec"][5],
  };
  return calAirconLoad(airConObj);
};

export const criticalLoad = (emsData) => {
  if (emsData != {} && emsData["PacketType"] == 1) {
    return calCriticalLoad(emsData["Inv"]["Volt"], emsData["Inv"]["Curr"]);
  } else {
    return null;
  }
};
export const criticalLoadGr = (emsData) => {
  return calCriticalLoad(emsData["inv"][0], emsData["inv"][1]);
};

export const getPowerObj = (emsData) => {
  var myDate = new Date();
  var load = aircon_EMS.includes(emsData["BatteryID"].split("_")[2])
    ? airConLoad(emsData)
    : criticalLoad(emsData);
  return {
    x: myDate.getTime(),
    y: parseFloat(load),
  };
};

export const graphObj = (emsObj, emsID, myDate) => {
  var load = aircon_EMS.includes(emsID)
    ? airConLoadGraph(emsObj)
    : criticalLoadGr(emsObj);
  return {
    x: myDate,
    y: parseFloat(load),
  };
};

export const emsDetailTabsArr = [
  "EMS DETAIL",
  "CHARTS",
  "COMMAND AND CONTROL",
  "EMS REPORT",
];
export const emsPacketTabsArr = ["BATTERY STATUS", "RECTIFIER", "INVERTER"];

export const cmdContCommands = [
  "Restart pi ",
  "Reset EMS",
  "Reset Error ",
  "Inverter OFF/ON",
  "Inverter Reset",
  "Sleep/Wakeup EMS",
  "MainContactor ON/OFF",
  "Charging ON/OFF",
  "Balancing ON/OFF",
  "EEPROM",
  "Weekend Cycling",
  "Custom Command",
];

// list of commands that can be send

export const command = [
  "RestartPi", //0
  "Reset", //1
  "ErrorReset", //2
  "InverterOFF", //3
  "InverterON", //4
  "InverterRESET", //5
  "Sleep", //6
  "Wakeup", //7
  "MainContactorON", //8
  "MainContactorOFF", //9
  "ChargingON", //10
  "ChargingOFF", //11
  "BalancingON", //12
  "BalancingOFF", //13
  "EEPROM", //14
  "WKCycling", //15
];

// const catEnum = Object.freeze({
//   BMSDATA: 0,
//   VOLTAGE: 1,
//   TEMP: 2,
//   SHUNT: 3,
//   REC: 4,
//   INV: 5,
//   AH_DATA: 6,
//   RESERR: 7,
// });
export const catList = [
  [0, "BMSDATA"],
  [1, "TEMP"],
  [3, "SHUNT"],
  [4, "REC"],
  [5, "AH_DATA"],
  [6, "INV"],
  [7, "RESERR"],
];
